<template>
    <b-card no-body class="overflow-hidden">
        <b-overlay :show="getting">
            <div class="row p-1">
                            <div class="col-md-1 mb-1 mb-md-0">
                                <select class="form-control bg-img-none" v-model="donem.month">
                                    <option v-for="m in months" :key="m.index" :value="m.index">{{m.name}}</option>
                                </select>
                            </div>
                            <div class="col-md-1 mb-1 mb-md-0">
                                <select class="form-control bg-img-none" v-model="donem.year">
                                    <option v-for="y in years" :key="y" :value="y">{{y}}</option>
                                </select>
                            </div>
                            <div class="col-md-auto mb-1 mb-md-0">
                                <select class="form-control bg-img-none" v-model="branchType">
                                    <option value="O">Org. Şube</option>
                                    <!-- <option value="S">SGK Şube</option>  -->
                                </select>
                            </div>
                            <div class="col-md-3 mb-1 mb-md-0" v-if="branchType == 'O'">
                                <v-select-list :options="branches" label="Name" v-model="branch" placeholder="Tüm Org. Şubeler"></v-select-list>
                            </div>
                            <!-- <div class="col-md-3 mb-1 mb-md-0" v-if="branchType == 'S'">
                                <v-select-list :options="sbranches" label="Name" v-model="sbranch" placeholder="Tüm SGK Şubeler"></v-select-list>
                            </div> -->
                            <div class="col-md-2 mb-1 mb-md-0">
                                <v-select-list :options="collarStatuses" label="Name" v-model="collarStatus" placeholder="Tüm Yakalar"></v-select-list>
                            </div>
                            <div class="col-auto">
                                <button class="btn btn-success" v-on:click="get">Sorgula</button>
                            </div>
                            <div class="col-auto" v-if="excelPath">
                                <button class="btn btn-outline-success" v-on:click="downloadExcel">Excel</button>
                            </div>
            </div>
            <div class="table-responsive mb-0">
                <table class="table table-sm bordered-header align-top">
                    <thead>
                        <tr>
                            <th>Dönem</th>
                            <th>Şube</th>
                            <th>Yaka</th>
                            <th class="w-20 text-right text-nowrap">Toplam Ücretler [VH]</th>
                            <th class="w-20 text-right text-nowrap">Toplam Vergi ve Harçlar</th>
                            <th class="w-20 text-right text-nowrap">Toplam Maliyet</th>
                            <th class="w-20 text-right text-nowrap">Çalışan Sayısı</th>
                            <th class="w-20 text-right text-nowrap">Kişi Başı Maliyet [TL/Kişi]</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(v,k) of grouped">
                            <template v-for="(item,i) in v">
                                <tr v-for="(collar,ci) in item.CollarStatusDatas" :key="`${k}-${i}-${ci}`">
                                    <td class="border-right text-nowrap font-weight-bolder bg-muted align-top" :rowspan="(v || []).reduce((sum,t)=> sum += (t.CollarStatusDatas || []).length + 1,0)" v-if="i == 0 && ci == 0">{{ k }}</td>
                                    <td class="border-right text-nowrap font-weight-bold align-top" :rowspan="(item.CollarStatusDatas).length + 1" v-if="ci == 0">{{ $safe(item,'Branch') || '**'}}</td>
                                    <td :title="[k,$safe(item,'Branch')].join(' - ')" class="border-right text-nowrap">{{ $safe(collar,'CollarStatus') || '**' }}</td>
                                    <td :title="[k,$safe(item,'Branch'),$safe(collar,'CollarStatus'),'Toplam Ücretler [VH]'].join(' - ')" class="border-right text-right">{{ $safe(collar,'TotalPricesStr') }}</td>
                                    <td :title="[k,$safe(item,'Branch'),$safe(collar,'CollarStatus'),'Toplam Vergi ve Harçlar'].join(' - ')" class="border-right text-right">{{ $safe(collar,'TotalTaxesStr') }}</td>
                                    <td :title="[k,$safe(item,'Branch'),$safe(collar,'CollarStatus'),'Toplam Maliyet'].join(' - ')" class="border-right text-right">{{ $safe(collar,'TotalAllStr') }}</td>
                                    <td :title="[k,$safe(item,'Branch'),$safe(collar,'CollarStatus'),'Çalışan Sayısı'].join(' - ')" class="border-right text-right">{{ $safe(collar,'TotalEmployees') }}</td>
                                    <td :title="[k,$safe(item,'Branch'),$safe(collar,'CollarStatus'),'Kişi Başı Maliyet [TL/Kişi]'].join(' - ')" class="text-right">{{ $safe(collar,'ExpensePerEmployeeStr') }}</td>
                                </tr>
                                <tr>
                                    <td class="border-right bg-muted font-weight-bold">Toplam</td>
                                    <td :title="['Toplam',k,$safe(item,'Branch'),'Toplam Ücretler [VH]'].join(' - ')" class="text-right border-right bg-muted">{{ $safe(item,'TotalPricesStr') }}</td>
                                    <td :title="['Toplam',k,$safe(item,'Branch'),'Toplam Vergi ve Harçlar'].join(' - ')" class="text-right border-right bg-muted">{{ $safe(item,'TotalTaxesStr') }}</td>
                                    <td :title="['Toplam',k,$safe(item,'Branch'),'Çalışan Sayısı'].join(' - ')" class="text-right border-right bg-muted">{{ $safe(item,'TotalAllStr') }}</td>
                                    <td :title="['Toplam',k,$safe(item,'Branch'),'Çalışan Sayısı'].join(' - ')" class="text-right border-right bg-muted">{{ $safe(item,'TotalEmployees') }}</td>
                                    <td :title="['Toplam',k,$safe(item,'Branch'),'Kişi Başı Maliyet [TL/Kişi]'].join(' - ')" class="text-right border-right bg-muted">{{ $safe(item,'ExpensePerEmployeeStr') }}</td>
                                </tr>
                            </template>
                        </template>
                        <template v-if="(datas || []).length == 0">
                            <tr>
                                <td colspan="100" class="text-center">Henüz bir veri bulunmamaktadır.</td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
        </b-overlay>
    </b-card>
</template>

<script>
import EmployeeOperationsApi from '@/api/employee-operations';
import { BCard, BOverlay } from 'bootstrap-vue';
import moment from 'moment'
import Additional from '@/utilities/additional'
import CompanyApi from '@/api/company'
import SystemDataApi from '@/api/system-data'

export default {
    components:{
        BCard,
        BOverlay
    },
    data(){
        return {
            getting:false,
            datas:[],
            donem:{
                year:moment().year(),
                month:moment().month() + 1 
            },
            excelPath:null,
            branches:[],
            sbranches:[],
            collarStatuses:[],
            branchType:'O',
            branch:null,
            sbranch:null,
            collarStatus:null,
            years:[],
            months:[
                {index:0,name:'TÜMÜ'},
                {index:1,name:'Ocak'},
                {index:2,name:'Şubat'},
                {index:3,name:'Mart'},
                {index:4,name:'Nisan'},
                {index:5,name:'Mayıs'},
                {index:6,name:'Haziran'},
                {index:7,name:'Temmuz'},
                {index:8,name:'Ağustos'},
                {index:9,name:'Eylül'},
                {index:10,name:'Ekim'},
                {index:11,name:'Kasım'},
                {index:12,name:'Aralık'}
            ],
            search:''
        }
    },
    mounted(){
        this.configureYears()
        this.get()
        this.getBranches()
        this.getSBranches()
        this.getCollarStatuses()
    },
    methods:{
        configureYears(){  
            let years = []
            let year = moment().add(1,'year').format('YYYY')
            let firstYear = 1900
            while (firstYear <= year){
                years.push(firstYear++)
            }
            this.years = years.reverse()
        },
        getBranches(){
            CompanyApi.Branch.ListByCode("O").then(res=>{
                this.branches = res.data.Data
            })
        },
        getSBranches(){
            CompanyApi.Branch.ListByCode("S").then(res=>{
                this.sbranches = res.data.Data
            })
        },
        getCollarStatuses(){
            SystemDataApi.CollarStatus().then(res => {
                this.collarStatuses = res.data.Data
            })
        },
        get(){
            this.getting = true
            EmployeeOperationsApi.Report.EmployeeExpenseMonthly({
                BranchId: this.branchType == 'O' ? (this.branch?.Id || null) : (this.sbranch?.Id || null),
                BranchTypeCode: this.branchType,
                CollarStatusId: this.collarStatus?.Id || null,
                Month: this.donem.month,
                Year: this.donem.year,
                PaginateRequest:{
                    QueryParam:this.search
                }
            }).then(res => {
                this.datas = res.data.Data || []
                this.excelPath = res.data.ExcelPath || null
                this.getting = false
            }).catch(err => {
                this.getting = false
            })
        },
        downloadExcel(){
            if(this.excelPath){
                Additional.DownloadTab(this.excelPath)
            }
        }
    },
    computed:{
        grouped(){
            return this.datas.reduce((obj,i) => {
                var my = [moment().month(i.Month - 1).locale('tr').format("MMMM"),i.Year].join(' ')
                if(obj[my]){ obj[my].push(...i.BranchDatas)}
                else { obj[my] = i.BranchDatas }
                return obj
            },{})
        },
        filter(){
            return {
                BranchId: this.branchType == 'O' ? (this.branch?.Id || null) : (this.sbranch?.Id || null),
                BranchTypeCode: this.branchType,
                CollarStatusId: this.collarStatus?.Id || null,
                Month: this.donem.month,
                Year: this.donem.year,
            }
        }
    }
}
</script>

<style>
.bg-muted{
    background-color: #f3f2f7;
}

.dark-layout .bg-muted{
    background-color: #343d55 !important;
}
</style>